import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { HiOutlineShoppingBag, HiOutlineMenu, HiOutlineX, HiOutlineSearch } from 'react-icons/hi';
import { useCart } from '../context/CartContext';

const Navbar: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { totalItems } = useCart();
  const location = useLocation();

  // Close menu on route change
  useEffect(() => {
    setIsOpen(false);
  }, [location]);

  // Prevent body scroll when mobile menu is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [isOpen]);

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <button className="mobile-menu-btn" onClick={() => setIsOpen(!isOpen)}>
          {isOpen ? <HiOutlineX size={24} /> : <HiOutlineMenu size={24} />}
        </button>

        <Link to="/" className="navbar-logo">YIBE</Link>

        {isOpen && (
          <div className="mobile-menu-overlay active" onClick={() => setIsOpen(false)} />
        )}

        <div className={`navbar-links ${isOpen ? 'active' : ''}`}>
          <Link to="/">Home</Link>
          <Link to="/shop">Shop All</Link>
          <Link to="/shop?category=dresses">Dresses</Link>
          <Link to="/shop?category=sets">Sets</Link>
          <Link to="/shop?category=gowns">Gowns</Link>
        </div>

        <div className="navbar-actions">
          <Link to="/shop" className="search-btn">
            <HiOutlineSearch size={22} />
          </Link>
          <Link to="/cart" className="cart-btn">
            <HiOutlineShoppingBag size={22} />
            {totalItems > 0 && <span className="cart-badge">{totalItems}</span>}
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
